function eventDdm() {
    $('.ddm--all-dates').dropDownMenu({
        disabled:    false,
        classBtn:    'button-1 button-1--calendar',
        independent: false
    });
}
